<div class="tr md-no-proxy hover padding-10 layout-row layout-align-start-center"
     (click)="onSelectAccount(account)">

  <!--Account Details-->
  <div class="flex-15 td small text-ellipsis layout-row layout-align-start-center">
    <app-account-avatar class="margin-right-20" [account]="account" [size]="'small'"></app-account-avatar>

    <div class="layout-column">
      <div class="layout-row layout-align-start-center">
        <app-demand-account-link class="flex" [account]="account" [isAllowCopyButton]="true"></app-demand-account-link>
        <span *ngIf="!account.active" class="blocked-badge margin-right-10 margin-right-5" translate>BLOCKED</span>
      </div>
      <app-bringoz-tags class="margin-top-5"
                        *ngIf="!!account.tags?.length"
                        [tags]="account.tags"
                        maxTags="2">
      </app-bringoz-tags>
    </div>
  </div>

  <!--External ID-->
  <div class="flex td small text-ellipsis layout-row layout-align-start-center">
    <span class="br-body-2 font-weight-400">{{account.externalId}}</span>
  </div>

  <!--Account Type-->
  <div class="flex td small text-ellipsis layout-row layout-align-start-center">
    <span class="br-body-2 font-weight-400">{{account.type | translate}}</span>
  </div>

  <!--Account Type-->
  <div class="flex td small layout-row layout-align-start-center">
    <span class="flex br-body-2 font-weight-400 text-ellipsis"
          [appBringozTooltip]="locationTooltip" [applyHoverColor]="true" ngbTooltip>
      {{account.address | bringozAddress}}
    </span>
    <app-address-quality [address]="account.address">
    </app-address-quality>
  </div>

  <ng-template #locationTooltip>
    <div class="layout-column layout-align-start-center">
      <div class="layout-column layout-align-start-center">
        <span class="br-body-2">{{ 'Address' | translate }}
          : {{ account.address | bringozAddress }}</span>
        <div class="layout-column layout-align-start-center">
                <span class="br-body-2 margin-right-10">{{ 'Floor' | translate }}
                  : {{ account.address.floor || '--' }}</span>
          <span class="br-body-2">{{ 'Apt' | translate }}: {{
              account.address.apartment || '--'
            }}</span>
        </div>
      </div>
    </div>
</ng-template>

<!--Shippers'-->
  <div class="flex td small text-ellipsis layout-row layout-align-start-center">
    <span class="br-body-2 font-weight-400">{{account.shippersIds?.length || 'N/A'}}</span>
  </div>

  <!--Phone-->
  <div class="flex td small text-ellipsis layout-row layout-align-start-center">
    <span class="br-body-2 font-weight-400">{{(account.phoneNumber | bringozPhone) || 'N/A'}}</span>
  </div>

  <!--Additional phone number-->
  <div class="flex td small text-ellipsis layout-row layout-align-start-center">
    <span class="br-body-2 font-weight-400">{{(account.additionalPhoneNumber | bringozPhone) || 'N/A'}}</span>
  </div>

  <!--Branches-->
  <div class="flex td small text-ellipsis layout-row layout-align-start-center">
    <branches-indicator [branches]="account.branchReferences"></branches-indicator>
  </div>

  <!--Category-->
  <div class="flex td small text-ellipsis layout-row layout-align-start-center">
    <span class="br-body-2 font-weight-400">{{account.businessCategory || 'N/A'}}</span>
  </div>

  <!--Created-->
  <div class="flex td small text-ellipsis layout-row layout-align-start-center">
    <span class="br-body-2 font-weight-400">{{account | bringozFullDate: 'createdAt'}}</span>
  </div>

  <!--Updated-->
  <div class="flex td small text-ellipsis layout-row layout-align-start-center">
    <span class="br-body-2 font-weight-400">{{account | bringozFullDate: 'updatedAt'}}</span>
  </div>

</div>
